import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../hoc/AxiosSetting/axios'
import S3FileUpload from 'react-s3';
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance';
import DatePicker from 'react-datepicker'

export default class competancyMatrix extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filenameToview: "",
            data: {},
            data1: {},
            listOfCompMatrix: {
                IQCPL: "",
                revisionNumber: "",
                revisionDate: ""
            },
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedMasterAgreementURL: "",
            submitStatus: true,
            messageforvalidation: "none",
            reporttype: "none",
            reporttype1: "none",

        }
        this.masteragreementUrlInput = React.createRef();
    }
    componentDidMount() {
        axios.get(APIURL + '/api/technicalexpert/get/listtechnicalexperts')
            .then(res => {
                this.setState({ data: res.data.response })
                console.log("res.data.response", res.data.response)
            })
        axios.get(APIURL + '/api/nace/get/nacecodeassignment')
            .then(res => {
                this.setState({ data1: res.data.response })
                console.log("data 1", res.data.response)
            })
    }
    handleDateChange = date => {
        const userData = this.state.listOfCompMatrix;
        userData['revisionDate'] = date;
        this.setState({ listOfCompMatrix: userData, dobError: "" });
    }
    handleChange = name => e => {
        var errorVar = e.target.name + "Error";
        const listOfCompMatrixData = this.state.listOfCompMatrix;
        listOfCompMatrixData[e.target.name] = e.target.value;
        this.setState({
            listOfCompMatrix: listOfCompMatrixData,
            [`${errorVar}`]: "",
        })
    }
    downloadPDF = () => {
        var jsonRequest = {
            IQCPL: this.state.listOfCompMatrix.IQCPL,
            revisionNumber: this.state.listOfCompMatrix.revisionNumber,
            revisionDate: this.state.listOfCompMatrix.revisionDate,
        }
        console.log("jsonRequest", jsonRequest)
        axios({
            method: 'POST',
            url: APIURL + '/api/generatepdf/post/competancymatrixpdf',
            data: jsonRequest,
            responseType: 'arraybuffer',
            headers: { 'Accept': 'application/pdf' }

        })

            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `CompetancyMatrix.pdf`
                link.click()
            })
    }
    render() {
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ minHeight: "450px" }}>
                                        <div className="row">
                                            <div className="formOuterDiv">

                                                <div className="row mt-3">
                                                    <div className='col-sm-2'><label>IQCPL</label></div>
                                                    <div className="col-sm-9">
                                                        <input type="text" className="formSingleElementField" name="IQCPL" onChange={this.handleChange("IQCPL")} value={this.state.listOfCompMatrix.IQCPL} />
                                                    </div></div>
                                                    <div className="row mt-4">
                                                    <div className='col-sm-2'><label>Revision Number</label></div>
                                                    <div className="col-sm-9">
                                                        <input type="text" className="formSingleElementField" name="revisionNumber" onChange={this.handleChange("revisionNumber")} value={this.state.listOfCompMatrix.revisionNumber} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <div className='col-sm-2'><label>Revision Date</label></div>
                                                    <div className="col-sm-9">
                                                        <DatePicker name="revisionDate" className="formSingleElementField" dateFormat="dd-MM-yyyy" selected={this.state.listOfCompMatrix.revisionDate} onChange={this.handleDateChange} />
                                                    </div>
                                                </div>
                                               
                                            </div>
                                            <div className='card-footer'>
                                                <div className="row">
                                                    <div className="col-sm-8" />
                                                    <div className="col-sm-4">
                                                        <button type="submit" className="btn btn-primary float-right" onClick={() => { this.downloadPDF() }}>Download Report</button>
                                                    </div>
                                                </div>
                                                </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </section>

                </div>
            </div>
        )
    }
}